const content = {
  hero: 'You saw it here first.',
  marquee: [
    'New York City',
    'Filmmaker',
    'Designer',
    'Musician',
    'Trendsetter',
  ],
  // gallery: {
  //   title: 'Featured Work',
  //   images: [
  //     {
  //       src: 'https://storage.googleapis.com/tiger-dc-web/images/sc1-interior/image-2160.webp',
  //       alt: 'gallery image',
  //       title: 'Musicbed - The Art of Sounds',
  //       url: '/work/musicbed-sounds',
  //     },
  //     {
  //       src: 'https://storage.googleapis.com/tiger-dc-web/images/sc1-interior/image-2160.webp',
  //       alt: 'gallery image',
  //       title: 'Thypoch - Finding Focus',
  //       url: '/work/thypoch-finding-focus',
  //     },
  //     {
  //       src: 'https://storage.googleapis.com/tiger-dc-web/images/sc1-interior/image-2160.webp',
  //       alt: 'gallery image',
  //       title: 'Bugatti - Tourbillion',
  //       url: '/work/bugatti-tourbillion',
  //     },
  //     {
  //       src: 'https://storage.googleapis.com/tiger-dc-web/images/sc1-interior/image-2160.webp',
  //       alt: 'gallery image',
  //       title: 'Adobe - Magical Edits 1',
  //       url: '/work/adobe-magical-edits-1',
  //     },
  //     {
  //       src: 'https://storage.googleapis.com/tiger-dc-web/images/sc1-interior/image-2160.webp',
  //       alt: 'gallery image',
  //       title: 'Adobe - Magical Edits 2',
  //       url: '/work/adobe-magical-edits-2',
  //     },
  //   ],
  // },
  clients: {
    title: 'Select Clients',
    galleryItems: [
      {
        src: 'https://storage.googleapis.com/tyronshi/collaborator-logos/adobe-w/s.webp',
        alt: 'adobe logo image',
        url: 'https://www.instagram.com/reel/DQWpb0KjawH/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
      },
      {
        src: 'https://storage.googleapis.com/tyronshi/collaborator-logos/samsung-w/samsung-w_s.webp',
        alt: 'samsung logo image',
        url: 'https://www.instagram.com/reel/DVv9oVdDfFu/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
      },
      {
        src: 'https://storage.googleapis.com/tyronshi/collaborator-logos/meta-w/meta-w_s.webp',
        alt: 'meta logo image',
        url: 'https://www.instagram.com/reel/DXzDoONtB11/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
      },
    ],
    cta: "Let's work together",
  },
  faq: [
    {
      title: 'Do you work with brands?',
      description:
        "Yes. If you're interested in us working together, please send a proposal or brief through the contact form here to start the conversation. All collaborations are subject to approval from me on a case-by-case basis.",
    },
    {
      title: 'Do you work with other artists or creators?',
      description:
        'Sometimes. This will depend on whether they and/or their project is a fit for me or not.',
    },
    {
      title: 'Are you available for hire?',
      description:
        "Not currently. Due to scheduling restrictions with my own work I don't have the capacity to work on freelance projects.",
    },
  ],
};
export default content;
